package fr.frux.shared.data.local

import fr.frux.core.database.FruxDatabase

/** Ligne unique `cluster_pyramid_cache`, le payload JSON est stocke sans interpretation. */
class SqlDelightClusterPyramidLocalDataSource(
    private val database: FruxDatabase,
) : ClusterPyramidLocalDataSource {
    override suspend fun read(): CachedClusterPyramid? =
        database.clusterPyramidCacheQueries
            .select()
            .executeAsOneOrNull()
            ?.let { CachedClusterPyramid(etag = it.etag, payload = it.payload, checkedAtMillis = it.checked_at) }

    override suspend fun write(
        etag: String?,
        payload: String,
        checkedAtMillis: Long,
    ) {
        database.clusterPyramidCacheQueries.put(etag = etag, payload = payload, checked_at = checkedAtMillis)
    }

    override suspend fun touch(checkedAtMillis: Long) {
        database.clusterPyramidCacheQueries.touch(checked_at = checkedAtMillis)
    }
}
